import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-base-dashboard',
  templateUrl: './base-dashboard.component.html',
  styleUrls: ['./base-dashboard.component.scss'],
})
export class BaseDashboardComponent {
  @Input() pageTitle: string = '';
  @Input() subtitle: string = '';
  @Input() icon: string = '';
  @Input() compactPadding = false;
  // You can add more inputs here like breadcrumbs, etc.
}
